module.exports = __webpack_public_path__ + "img/foot-logo.a60dfadd.png";